// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';
import Decimal from 'decimal.js';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [data1, setData1] = useState([]);
  const token = authServices.getToken();

  const SubSubCommodity = async () => {
    try {
      const response = await apiClient.get(`/api/admin/sub_sub_commodity/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData1(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData1 = Array.from(
    new Map(data1.map((item) => [item.subSubCommodity, item])).values()
  );

  const validData1 = filteredData1.filter((item) => item.subSubCommodity);

  // *******************************************************************************************************************************
  const [data2, setData2] = useState([]);

  const fetchPortType = async () => {
    try {
      const response = await apiClient.get(`/api/admin/port_type/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData2(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData2 = Array.from(
    new Map(data2.map((item) => [item.portType, item])).values()
  );

  const validData2 = filteredData2.filter((item) => item.portType);

  const [data3, setData3] = useState([]);

  const fetchUnit = async () => {
    try {
      const response = await apiClient.get(`/api/admin/unit/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData3(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData3 = Array.from(
    new Map(data3.map((item) => [item.name, item])).values()
  );

  const validData3 = filteredData3.filter((item) => item.name);

  const [LableData, setLableData] = useState({
    subSubCommodityId: null,
    unitId: null,
    portTypeId: null,
  })

  const [formData, setFormData] = useState({

    id: invoiceId,
    subSubCommodityId: null,
    unitId: null,
    portTypeId: null,
    charges: null,
  });

  console.log("charges formData", formData)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  //*********************************** Fetch invoice data when the modal opens ********************************************************

  const fetchInvoiceData = async () => {
    if (edit && invoiceId) {
      loader('enable');

      try {
        const response = await apiClient.get(`/api/admin/charges/${invoiceId}`, {

          headers: {
            'access_token': token,
          },

        });
        if (response.data.Status === "SUCCESS") {

          // Form data ko set karna
          setFormData({
            id: invoiceId || '',
            subSubCommodityId: response.data.data.subSubCommodityId.id || '',
            unitId: response.data.data.unitId.id || '',
            portTypeId: response.data.data.portTypeId.id || '',
            charges: response.data.data.charges || '',
          });

          setLableData({
            subSubCommodityId: response.data.data.subSubCommodityId.subSubCommodity || '',
            unitId: response.data.data.unitId.name || '',
            portTypeId: response.data.data.portTypeId.portType || '',
          });
        }
        else {
          console.log(response.data.message)
        }
      } catch (error) {
        console.error('catch Error :- ', error.response ? error.response.data.message : error);
      } finally {
        loader('disable');
      }
    }
  };



  //******************************************* Handle save and update the data **************************************************

  const AllData = {
    id: formData.id,
    subSubCommodityId: {
      id: formData.subSubCommodityId
    },
    unitId: {
      id: formData.unitId
    },
    portTypeId: {
      id: formData.portTypeId
    },
    charges: new Decimal(formData.charges ? formData.charges : 0.00).toFixed(2) || 0.00,
  }


  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/charges/update`, AllData, {

        headers: {
          'access_token': token,
        },
      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };

  useEffect(() => {
    fetchInvoiceData();
    fetchUnit()
    fetchPortType()
    SubSubCommodity()
  }, [invoiceId, edit]);


  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Charges
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className="row w-100">
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="subSubCommodityId" className="label-custom">Sub Sub Commodity</label>
                      <Autocomplete
                        // className={` ${errors.subSubCommodityId ? 'input-error' : ''}`}
                        disablePortal
                        options={validData1} // Full user object
                        getOptionLabel={(option) => option.subSubCommodity} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label={LableData.subSubCommodityId} />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, subSubCommodityId: value.id }); // Save 'id' in state
                          } else {
                            setFormData({ ...formData, subSubCommodityId: "" }); // Reset state 
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.subSubCommodity}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '120px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                    </div>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="unitId" className="label-custom">Unit</label>
                      <Autocomplete
                        // className={` ${errors.unitId ? 'input-error' : ''}`}
                        disablePortal
                        options={validData3} // Full user object
                        getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label={LableData.unitId} />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, unitId: value.id }); // Save 'id' in state 
                          } else {
                            setFormData({ ...formData, unitId: "" }); // Reset state 
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '120px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="row w-100">
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="portTypeId" className="label-custom">Port Type</label>
                      <Autocomplete
                        // className={` ${errors.portType ? 'input-error' : ''}`}
                        disablePortal
                        options={validData2} // Full user object
                        getOptionLabel={(option) => option.portType} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label={LableData.portTypeId} />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, portTypeId: value.id }); // Save 'id' in state
                          } else {
                            setFormData({ ...formData, portTypeId: "" }); // Reset state 
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.portType}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '120px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                    </div>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="charges" className="label-custom">Charges</label>
                      <input
                        type="text"
                        className="number-input"
                        id="charges"
                        name="charges"
                        value={formData.charges}
                        onChange={handleChange}
                        onInput={(e) => {
                          // Allow digits and a single decimal point
                          e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Only allow digits and dots
                          // Prevent more than one decimal point
                          if ((e.target.value.match(/\./g) || []).length > 1) {
                            e.target.value = e.target.value.replace(/\.+$/, '');
                          }
                        }}
                      />
                    </div>
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
